<template>

    <div ref="anonyMount"></div>

</template>

<script>

import Vue from 'vue';
import ProductsWidget from "./ProductsWidget.vue";

export default {

    mounted() {
        let res = Vue.compile('<div>' + this.htmlContent + '</div>');

        new Vue({
            parent: this,
            render: res.render,
            staticRenderFns: res.staticRenderFns,
            components: { ProductsWidget },
        }).$mount(this.$refs.anonyMount);
    },

    props: {
        htmlContent: {
            required: true,
            type: String,
        },
    }

}

</script>
